import {Tag} from 'folder-items/FileConstants';
import {Thunk} from 'redux-stores/Store';
import {updateAssayRun} from 'results/assays/AssayRecordActions';
import * as TagUtil from 'schemas/tags/TagUtil';

export function updateTagsForAssayRun(
  assayRunId: string,
  cid: string,
  tags: Array<Tag>,
  connectionId: string | null,
  equipmentId: string | null,
  studyIds: Array<string>
): Thunk<Promise<void>> {
  return (dispatch) => {
    const updateAssayRunData = {tags: TagUtil.getTagsToSet(tags), connectionId, equipmentId, studyIds};
    return dispatch(updateAssayRun(assayRunId, updateAssayRunData));
  };
}
